import { useState } from 'react';
import useApp from '../AppContext';
import { callApi, ErrorAlert, SuccessAlert } from '../crud/utils';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './../Login.css';
import './../Forgot Password/ForgotPass.css';
import { useNavigate } from "react-router-dom";
import { t } from './../i18n'

function ForgotPass(props) {
    const app = useApp();
    const [email, setEmail] = useState("");
    const [isBtnActiveFlg, setIsBtnActiveFlg] = useState(true);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const language = localStorage.getItem('preferredLanguage') || app.sessionToken?.Language
    let navigate = useNavigate();


    async function requestForgotPass() {
        setIsBtnActiveFlg(false);

        if (isBtnActiveFlg) {
            const url = `${app.serverUrl}/api/forgotpassword?userEmail=${email}`;
            try {
                const response = await callApi('POST', url, props.userToken, null);
                if (response.error) {
                    setError(response.error);
                    return;
                }
                setSuccessMessage(t('passwordReset.successMessage', language));
                setIsBtnActiveFlg(true)
                setTimeout(() => {
                    navigate("/login", { replace: true });
                }, 7500);
            } catch (error) {
                setError(error.message);
                setIsBtnActiveFlg(true);
            }
        }
    }


    function whenLoggedOff() {
        const parsedCustomStyle = app.sessionToken?.CustomStyle
            ? JSON.parse(app.sessionToken.CustomStyle)
            : {};

        const logoPath = parsedCustomStyle.Logo
            ? `${app.serverUrl}${parsedCustomStyle.Logo}`
            : 'images/Logo-Yard.png';
        return (
            <>
                <div className='container-for-all-login' style={{ color: app.theme === 'dark' ? 'white' : '#000' }}>
                    <img
                        style={{ height: "200px" }}
                        src={logoPath}
                        alt='Company-Logo'
                    />
                    <Form onSubmit={(e) => { e.preventDefault() }} style={{ background: app.theme === "dark" ? "#4e4e4eff" : "white" }}>
                        <h4>{t('passwordReset.title', language)}</h4>
                        <Form.Group className="mb-2">
                            <Form.Label>{t('passwordReset.title', language)}<b>*</b></Form.Label>
                            <Form.Control onChange={(e) => setEmail(e.target.value)} value={email} type="email" placeholder={t('passwordReset.emailPlaceholder', language)} />
                        </Form.Group>
                        <div className='container-signup-split-inputs mt-3'>
                            <Form.Group>
                                <Button onClick={() => navigate('/')} variant="secondary" className='secondary-btn-signup'>
                                    {t('common.backButton', language)}
                                </Button>
                            </Form.Group>
                            <Form.Group >
                                <Button onClick={() => requestForgotPass()} variant="primary" type="submit" className='primary-btn-signup'>
                                    {t('common.resetButton', language)}
                                </Button>
                            </Form.Group>
                        </div>
                    </Form>
                </div>
                <img src={app.theme === "light" ? '/images/Entersoft-Logo-Login-light.png' : '/images/Entersoft-Logo-Login-dark.png'} alt='Logo-Entersoft' className='Entersoft-Logo-Login' />
                {logoPath !== 'images/Logo-Yard.png' && <img src={app.theme === "light" ? '/images/Aberon-Logo-Login-light.png' : '/images/Aberon-Logo-Login-dark.png'} alt='Logo-Aberon' className='Aberon-Logo-Login' />}
                {!isBtnActiveFlg && <div className='container-loading'><div className="loader"></div></div>}
            </>
        );
    }

    function createContent() {
        if (!app.user) {
            return whenLoggedOff();
        }
    }

    return (
        <div className="mt-4">
            <SuccessAlert message={successMessage} setMessage={setSuccessMessage} language={language} />
            <ErrorAlert message={error} setMessage={setError} language={language} />
            {createContent()}
        </div>
    );
}

export default ForgotPass;
